module.exports = __webpack_public_path__ + "img/violet_051.a0928a16.png";